import { useQuery } from '@tanstack/react-query';
import { MaterialCatalog } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const MATERIAL_CATALOG_QUERY_KEY = ['materialCatalog'];

export const useMaterialCatalog = () => {
  return useQuery<MaterialCatalog[], Error>({
    queryKey: MATERIAL_CATALOG_QUERY_KEY,
    queryFn: async () => {
      const catalog = await warehouseService.getMaterialCatalog();
      return catalog || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useMaterialCatalogItem = (catalogId: string | undefined) => {
  return useQuery<MaterialCatalog, Error>({
    queryKey: [...MATERIAL_CATALOG_QUERY_KEY, catalogId],
    queryFn: async () => {
      if (!catalogId) throw new Error('catalogId is required');
      return await warehouseService.getMaterialCatalogItem(catalogId);
    },
    enabled: !!catalogId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useSearchMaterialCatalog = (search: string) => {
  return useQuery<MaterialCatalog[], Error>({
    queryKey: [...MATERIAL_CATALOG_QUERY_KEY, 'search', search],
    queryFn: async () => {
      if (!search || search.length < 2) return [];
      const results = await warehouseService.searchMaterialCatalog(search);
      return results || [];
    },
    enabled: search.length >= 2,
    staleTime: 1 * 60 * 1000, // 1 minute for search results
  });
};

export default useMaterialCatalog;
